"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAICPAId = (id) => {
    const stringifiedId = `${id}`;
    return stringifiedId.startsWith('00') && stringifiedId.length === 9
        ? stringifiedId.slice(2, stringifiedId.length)
        : stringifiedId;
};
//# sourceMappingURL=index.js.map